/**
 * Classes for form field markup that jQuery builds. They match what the
 * x-form-group Blade components render, so a field looks the same whether it
 * came from the server or from JS. Change both together.
 */
export const formClassNames = {
    formGroup: 'form-group',
    input: 'form-control',
    select: 'form-control m-bootstrap-select m_selectpicker',
    checkbox: 'form-check-input',
    invalid: 'is-invalid',
    invalidFeedback: 'invalid-feedback',
};

/**
 * Label classes of resources/views/components/form-group/checkbox.blade.php for
 * the same props.
 */
export function checkboxLabelClassNames({
    single = false,
    size = 'md',
    tone = null,
    bold_check = false,
} = {}) {
    return [
        'm-checkbox',
        'm-checkbox--bold',
        'mb-0',
        single ? 'm-checkbox--single' : null,
        size === 'sm' ? 'm-checkbox--sm m--regular-font-size-sm1' : null,
        tone ? 'm-checkbox--' + tone : null,
        bold_check ? 'm-checkbox--check-bold' : null,
    ]
        .filter(Boolean)
        .join(' ');
}

/**
 * Data attributes the x-form-group components emit as hooks.
 */
export const formHooks = {
    formGroup: 'data-form-group',
    choiceList: 'data-choice-list',
    errorFor: 'data-error-for',
};
